/**
* SNIPPET - ITEM CART - LISTENERS
*/

setupEventListenersForCartItems();

// Creates the event listeners
function setupEventListenersForCartItems() {
  // On clicking on the "Modify my choices" link in the details of a bundle
  document.querySelectorAll('[data-action="modify-bundle"]').forEach((element) => {
    element.addEventListener('click', clickModifyBundleHandler);
  });
  
  // When the value of an input quantity changes
  document.querySelectorAll('.item-cart .product__quantity-value').forEach((element) => {
    element.addEventListener('change', changeCartItemQuantityInputHandler);
  });
  
  // When changing the variant
  document.querySelectorAll('.item-cart .product__variant-switcher select').forEach((element) => {
    element.addEventListener('change', changeCartItemVariantHandler);
  });
  
  // On clicking on a checkbox linked to the subscription
  document.querySelectorAll('.item-cart [data-smartrr-selling-plan-group-input]').forEach((element) => {
    element.addEventListener('click', toggleCartItemSubscriptionHandler);
  });
  
  // When changing the frequency of the subscription
  document.querySelectorAll('.item-cart [data-smartrr-selling-plans-select]').forEach((element) => {
    element.addEventListener('change', changeCartItemSubscriptionHandler);
  });
  
  // On clicking on the - button of the quantity in a cart sidebar item
  document.querySelectorAll('.item-cart-sidebar [data-action="sub-product"]').forEach((element) => {
    element.addEventListener('click', clickCartItemSidebarSubQuantityHandler);
  });
  
  // On clicking on the + button of the quantity in a cart sidebar item
  document.querySelectorAll('.item-cart-sidebar [data-action="add-product"]').forEach((element) => {
    element.addEventListener('click', clickCartItemSidebarAddQuantityHandler);
  });
  
  // On clicking on the x button in a cart sidebar item
  document.querySelectorAll('.item-cart-sidebar [data-action="remove-product"]').forEach((element) => {
    element.addEventListener('click', clickCartItemSidebarRemoveHandler);
  });
}

/**
* SNIPPET - ITEM CART - GENERAL
*/

// On clicking on the "Modify my choices" link in the details of a bundle
function clickModifyBundleHandler() {
  event.preventDefault();
  deleteBundle();
}

// When the value of an input quantity changes
function changeCartItemQuantityInputHandler() {
  changeCartItemQuantityInput();
}

// When changing the variant
function changeCartItemVariantHandler() {
  changeCartItemVariant();
}

// On clicking on a checkbox linked to the subscription
function toggleCartItemSubscriptionHandler() {
  changeCartItemSellingPlan(false);
}

// When changing the frequency of the subscription
function changeCartItemSubscriptionHandler() {
  changeCartItemSellingPlan(true);
}

// Change the quantity of an item in the cart
function changeCartItemQuantity(sectionPage, itemCart, itemCartNumber, quantity) {
  const body = JSON.stringify({
    line: itemCartNumber,
    quantity: quantity
  });

  fetch(`${routes.cartChangeUrl}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {   
      isPage('/cart') ? location.reload() : renderCartSidebar();
    })
    .catch((error) => {
      handleCartItemError(sectionPage, error);
    });
}

// Manages the actions to be taken if there is an error after an action from a cart item
function handleCartItemError(sectionPage, error) {
  console.log(error.responseJSON.description);

  if (!isPage('/cart') && sectionPage != '') sectionPage.classList.remove('cart--reloading');
}

// Removes the bundle to be modified from the cart
function deleteBundle() {
  var target = event.currentTarget,
      modal = target.closest('.modal'),
      itemCartNumber = modal.dataset.cartItemNumber;

  const body = JSON.stringify({
    line: itemCartNumber,
    quantity: 0
  });

  fetch(`${routes.cartChangeUrl}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {   
      window.location.href = target.getAttribute('href');
    })
    .catch((error) => {
      handleCartItemError('', error);
    });
}

// Change the value of an item in the cart
function changeCartItemQuantityInput() {
  var target = event.currentTarget,
      itemCart = target.closest('.item-cart'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      quantity = parseInt(target.value);

  // We add 1 because Shopify uses 1-index numbering
  window.location.href = window.theme.localeRootUrl + '/cart/change?quantity=' + quantity + '&line=' + itemCartNumber;
}

// Change the variant of an item in the cart
function changeCartItemVariant() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemCart = target.closest('.item-cart'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      variantId = parseInt(target.value),
      quantity = itemCart.querySelector('.product__quantity-value'),
      sellingPlanGroupId = itemCart.querySelector('[data-smartrr-selling-plan-group-id]'),
      sellingPlanGroupContents = null,
      sellingPlansSelect = null,
      sellingPlan = null,
      productProperties = itemCart.querySelectorAll('.product-property'),
      properties = new Object();
  
  if (sellingPlanGroupId !== null) sellingPlanGroupContents = sellingPlanGroupId.querySelector('[data-smartrr-selling-plan-group-contents]');
  if (sellingPlanGroupContents !== null) sellingPlansSelect = sellingPlanGroupContents.querySelector('[data-smartrr-selling-plans-select]');

  if (!isPage('/cart')) sectionPage.classList.add('cart--reloading');
  quantity === null ? quantity = 1 : quantity = parseInt(quantity.textContent);
  if (isNaN(quantity)) quantity = quantity.value;
  if (sellingPlanGroupId !== null) sellingPlan = parseInt(sellingPlansSelect.value);

  productProperties.forEach((element) => {
    var propertyFirst = element.querySelector('dt').textContent.split(':').shift().trim(),
        propertyLast = element.querySelector('dd').textContent.trim();
    
    properties[propertyFirst] = propertyLast;
  });

  // We delete the current variant from the cart
  const body = JSON.stringify({
    line: itemCartNumber,
    quantity: 0
  });

  fetch(`${routes.cartChangeUrl}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {  
      // We add the new variant to the cart 
      addCartItemVariant(variantId, quantity, sellingPlan, properties);
    })
    .catch((error) => {
      handleCartItemError(sectionPage, error);
    });  
}

// Adds a variant to the cart
function addCartItemVariant(variantId, quantity, sellingPlan, properties) {
  const body = JSON.stringify({
    id: variantId,
    quantity: quantity,
    selling_plan: sellingPlan,
    properties: properties
  });

  fetch(`${routes.cartAddUrl}.js`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((response) => {
      isPage('/cart') ? location.reload() : renderCartSidebar();
    })
    .catch((error) => {
      handleCartItemError(sectionPage, error);
    });
}

// Change the selling plan of an item in the cart
function changeCartItemSellingPlan(update_frequency) {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemCart = target.closest('.item-cart'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      quantity = itemCart.querySelector('.product__quantity-value'),
      sellingPlanGroupId = target.closest('[data-smartrr-selling-plan-group-id]'),
      sellingPlanGroupContents = null,
      sellingPlansSelect = null,
      sellingPlan = null;

  if (sellingPlanGroupId !== null) sellingPlanGroupContents = sellingPlanGroupId.querySelector('[data-smartrr-selling-plan-group-contents]');
  if (sellingPlanGroupContents !== null) sellingPlansSelect = sellingPlanGroupContents.querySelector('[data-smartrr-selling-plans-select]');

  if (!isPage('/cart')) sectionPage.classList.add('cart--reloading');
  quantity === null ? quantity = 1 : quantity = parseInt(quantity.textContent);
  if (isNaN(quantity)) quantity = quantity.value;
  if (!sellingPlanGroupId.classList.contains('smartrr-group-active') || update_frequency) sellingPlan = parseInt(sellingPlansSelect.value);

  // We change the saved selling plan information
  const body = JSON.stringify({
    line: itemCartNumber,
    quantity: quantity,
    selling_plan: sellingPlan
  });

  fetch(`${routes.cartChangeUrl}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {   
      isPage('/cart') ? location.reload() : renderCartSidebar();
    })
    .catch((error) => {
      handleCartItemError(sectionPage, error);
    });
}

/**
 * SNIPPET - ITEM CART - SIDEBAR
 */

// On clicking on the - button of the quantity in a cart sidebar item
function clickCartItemSidebarSubQuantityHandler() {
  event.preventDefault();
  subProduct();
}

// On clicking on the + button of the quantity in a cart sidebar item
function clickCartItemSidebarAddQuantityHandler() {
  event.preventDefault();
  addProduct();
} 

// On clicking on the x button in a cart sidebar item
function clickCartItemSidebarRemoveHandler() {
  event.preventDefault();
  removeProduct();
} 

// Reduces the quantity of an item in the cart
function subProduct() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemCart = target.closest('.item-cart-sidebar'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      quantity = parseInt(itemCart.querySelector('.product__quantity-value').textContent) - 1;

  sectionPage.classList.add('cart--reloading');
  changeCartItemQuantity(sectionPage, itemCart, itemCartNumber, quantity);

  return false;
};

// Increases the quantity of an item in the cart
function addProduct() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemCart = target.closest('.item-cart-sidebar'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      quantity = parseInt(itemCart.querySelector('.product__quantity-value').textContent) + 1;

  sectionPage.classList.add('cart--reloading');
  changeCartItemQuantity(sectionPage, itemCart, itemCartNumber, quantity);

  return false;
};

// Removes an item from the cart
function removeProduct() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemCart = target.closest('.item-cart-sidebar'),
      itemCartNumber = parseInt(itemCart.dataset.cartItemNumber),
      quantity = 0;

  sectionPage.classList.add('cart--reloading');
  changeCartItemQuantity(sectionPage, itemCart, itemCartNumber, quantity);

  return false;
};